import styled from "styled-components"

export const StyledSearchIngredients = styled.div`
  --header-height: 44px;
  --input-height: 35px;
  height: calc(100% - var(--header-height));
`

export const SearchResultWrapper = styled.div`
  height: calc(100% - var(--input-height));
`
